import { Modal } from 'antd'
import React from 'react'
import UserDetail from './UserDetail'

const UserDetailModalV2 = props => {
  const { open, setOpen, selectedUser } = props

  return (
    <Modal
      style={{
        top: 20,
      }}
      title="Thông tin nhân viên"
      open={open}
      onCancel={() => {
        setOpen(false)
      }}
      footer={null}
      wrapClassName="custom-modal-wrapper"
      width={650}>
      <UserDetail selectedUser={selectedUser} />
    </Modal>
  )
}

export default UserDetailModalV2
